<template>
  <div class="login-container">
    <div class="gray-box">
      <div class="login-box">
        <div class="logo">
          <img src="../assets/AMD_LOGO.jpg" alt="TNT Logo" />
        </div>
        <h2>Login</h2>
        <form @submit.prevent="handleLogin">
          <div class="form-group">
            <input
              type="email"
              v-model="loginEmail"
              placeholder="Email"
              required
            />
          </div>
          <div class="form-group">
            <input
              type="password"
              v-model="loginPassword"
              placeholder="Password"
              required
            />
          </div>
           <!-- Error Message -->
          <!-- <p v-if="loginError" class="error-message">{{ loginError }}</p> -->
          <button type="submit" class="btn-login">Login</button>
        </form>
        <div class="links">
          <a href="/forgetPassword">Forgot your password?</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import '../firebaseDB.js'
import {
  getAuth,
  signInWithEmailAndPassword,
  browserSessionPersistence,
  setPersistence,
} from "firebase/auth";
// import {
//   getAuth,
//   signInWithEmailAndPassword,
//   browserSessionPersistence,
//   setPersistence,
// } from "firebase/auth";
import router from "@/router";
import store from "../store";
import { useToast } from 'vue-toastification'
import axios from "axios";

export default {
  data() {
    return {
      loginEmail: "",
      loginPassword: "",
      loginError: "",
      // $apiURL: "http://127.0.0.1:5001",
      // $apiURL: "https://amdtransportation-be-main-build-159134604691.us-central1.run.app"

    };
  },
  setup() {
    const toast = useToast()

    return {
      toast
    }
  },
  methods: {
    async getIdToken() {
      const auth = getAuth();
      const user = auth.currentUser;
      if (!user) {
        throw new Error("User not logged in");
      }
      return await user.getIdToken(); // 🔹 This is the token you'll send to the backend
    },
    async handleLogin() {
      const auth = getAuth();
      try {
        await setPersistence(auth, browserSessionPersistence);

        const userCredential = await signInWithEmailAndPassword(
          auth,
          this.loginEmail,
          this.loginPassword
        );

        const userid = userCredential.user.uid;
        store.commit("addUserId", userid);

        // 🔹 Fetch Firebase token
        const token = await userCredential.user.getIdToken();

        // 🔹 Call system access API
        const res = await axios.get(`${this.$apiURL}/api/systemAccess`, {
          headers: {
            Authorization: token
          }
        });

        if (res.data && res.data.claims) {
          const claims = res.data.claims;

          // 🔹 Save to Vuex
          store.commit("addSystemAccess", claims);
          console.log("System Access saved:", claims);

          // 🔹 Route based on role
          if (claims.admin === true) {
            router.push("/crm");
          } else if (claims.client === true) {
            router.push("/booking");
          } else if (claims.driver === true) {
            router.push("/DriverJob");
          } else {
            // Default fallback
            router.push("/");
          }
        } else {
          this.toast.error("No access rights found.");
        }

      } catch (error) {
        console.error("Login error:", error);
        this.toast.error("Incorrect Username/Password");
      }
    }

  },
};
</script>

<style scoped>
/* General Container */
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f9f9f9;
  padding: 20px;
}
.error-message {
  color: red;
  font-size: 0.9rem;
  margin-bottom: 15px;
  text-align: left;
}

/* Gray Box */
.gray-box {
  width: 600px; /* Larger gray box */
  padding: 40px;
  border-radius: 20px;
  background-color: #d3d3d3; /* Light gray background */
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

/* Login Box */
.login-box {
  width: 400px;
  padding: 30px;
  border-radius: 15px;
  /* background: #ffffff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); */
  text-align: center;
  margin: auto; /* Center the login box inside the gray box */
}

/* Logo */
.logo {
  margin-bottom: 20px;
}

.logo img {
  max-width: 50%;
  height: auto;
  display: block;
  margin: 0 auto;
}

/* Login Heading */
h2 {
  font-size: 1.5rem;
  margin-bottom: 20px;
  color: #333;
}

/* Form */
.form-group {
  margin-bottom: 15px;
}

.form-group input {
  width: 100%;
  padding: 10px;
  border: 1px solid #aaa;
  border-radius: 5px;
  font-size: 1rem;
}

/* Button */
.btn-login {
  width: 100%;
  padding: 10px;
  font-size: 1rem;
  color: #fff;
  background-color: #000;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.btn-login:hover {
  background-color: #333;
}

/* Links */
.links {
  margin-top: 20px;
}

.links a {
  color: #000;
  text-decoration: none;
  font-size: 0.9rem;
  margin: 0 10px;
}

.links a:hover {
  text-decoration: underline;
}

/* Mobile Responsive Design */
@media screen and (max-width: 480px) {
  .gray-box {
    width: 90%; /* Gray box adjusts for smaller screens */
    padding: 20px;
  }

  .login-box {
    width: 100%; /* Login box remains proportional inside gray box */
    padding: 20px;
  }

  h2 {
    font-size: 1.2rem;
  }

  .form-group input {
    padding: 8px;
    font-size: 0.9rem;
  }

  .btn-login {
    padding: 8px;
    font-size: 0.9rem;
  }

  .links a {
    font-size: 0.8rem;
  }
}
</style>
